import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";

import { C8VALI } from "../../../Validation";
// import { FormControl } from "react-bootstrap";
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import ComponentLoader from "../../../../ComponentLoader";

function C8Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [LovGrouptype, setLovGrouptype] = useState([]);

  const [OrganizationGrouptype,setOrganizationGrouptype] = useState("")
  const [OrganizationName, setOrganizationName] = useState("");
  const [Noofmembers, setNoofmembers] = useState("");
  const [Activities, setActivities] = useState("");

  const [OrganizationGrouptypeErr,setOrganizationGrouptypeErr] = useState(false)
  const [OrganizationNameErr, setOrganizationNameErr] = useState(false);
  const [NoofmembersErr, setNoofmembersErr] = useState(false);
  const [ActivitiesErr, setActivitiesErr] = useState(false);
  const [loader,setLoader] =useState(true);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(C8VALI),
  });

  const backs = () => {
    navigate("/C8");
  };

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      handleLov(tok)
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head(" SHG created");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);

  const edit = (item) => {
    console.log(item);
    setOrganizationGrouptype(item.groupType);
    setOrganizationName(item.activities);
    setNoofmembers(item.noofmembers);
    setActivities(item.activities);
    setId(item.id);
  };

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };
 
  // Lov Group Type
  const handleLov = async (token, GroupType) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"GroupType"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setLovGrouptype(data);setLoader(false);
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };


  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);

    const d = {
      id,
      GroupType: OrganizationGrouptype,
      NameoftheFPO: OrganizationName,
      Activities: Activities,
      Noofmembers: Noofmembers,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.C8SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/C8");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }
        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.C8EDIT}`, d, {
          headers: h,
        });
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/C8");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun=()=>{
    if(!OrganizationGrouptype){
      setOrganizationGrouptypeErr(true)
      document.getElementById("OrganizationGrouptype").focus()
    }else if(!OrganizationName){
      setOrganizationNameErr(true)
      document.getElementById("OrganizationName").focus()
    }else if(!Noofmembers){
      setNoofmembersErr(true)
      document.getElementById("Noofmembers").focus()
    }else if(!Activities){
      setActivitiesErr(true)
      document.getElementById("Activities").focus()
    }else{
      handleLeavepage()
    }
  }

  return (
    <div style={{ marginTop: 70 }}>
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>(C8). FPO & SHG Facilitated</span>
        </div>
      </div>

      <div className="from-mains">
        <div className="form-control">
          <h5 style={{ margin: 20 }}>C8. FPO / SHG created / facilitated</h5>


          <FormControl style={{ width: "48%", margin: 12 }} error={OrganizationGrouptypeErr} id="OrganizationGrouptype">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Organization/Group Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="MeetingName"
              value={OrganizationGrouptype}
              label="Programme Type"
              size="small"
              // style={{ margin: "10px", width: "48%" }}
              // sx={{ width: "100%" }}
              onChange={(e) => {
                setOrganizationGrouptype(e.target.value)
                setOrganizationGrouptypeErr(false)
              }}
            >
              {LovGrouptype?.map((row) => {
                return (
                  <MenuItem key={row.lovName} value={row.lovName}>
                    {row.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={OrganizationNameErr}
            id="OrganizationName"
            label="Organization Name"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={OrganizationName}
            onChange={(e) => {
              setOrganizationName(e.target.value)
              setOrganizationNameErr(false)
            }}
          />

          <TextField
            error={NoofmembersErr}
            id="Noofmembers"
            label="No. of Members"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={Noofmembers}
            onChange={(e) => {
              setNoofmembers(e.target.value)
              setNoofmembersErr(false)
            }}
          />

          <TextField
            error={ActivitiesErr}
            id="Activities"
            label=" Activities done in this month (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={Activities}
            onChange={(e) => {
              setActivities(e.target.value)
              setActivitiesErr(false)
            }}
          />


          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA", height: "20px",padding:"5px 30px 28px 26px",borderRadius:"3px",color:"#fff" }}
              onClick={backs}
            >
              Back
            </button>
            <button type="submit" className="sbmit-buttons" onClick={()=>formValidateFun()} style={{paddingTop:"5px"}}>
            Save
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default C8Inside;
